<template>
  <section class="bm-main-image">
    <header class="bm-main-image__head">
      <div class="bm-main-image__crumb">
        <button @click="$emit('back')">‹ 返回</button>
        <span>
          云库工作台 › 批量修改 ›
          <strong>商品主图</strong>
        </span>
        <a>帮助教程</a>
      </div>
      <h1>批量修改商品主图</h1>
      <nav>
        <button
          class="mode-range"
          :class="{ active: mode === 'range' }"
          @click="switchMode('range')"
        >
          按范围修改
        </button>
        <button
          class="mode-goods"
          :class="{ active: mode === 'goods' }"
          @click="switchMode('goods')"
        >
          按商品修改
        </button>
      </nav>
    </header>
    <main class="bm-main-image__body">
      <section v-if="mode === 'range'" class="bm-main-image__filter">
        <div v-for="field in fields" :key="field.key" class="bm-main-image__field">
          <label>{{ field.label }}</label>
          <el-select
            v-if="field.select"
            v-model="filterValues[field.key]"
            class="bm-main-image__filter-select"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="o in optionsFor(field.key)"
              :key="o.value"
              :label="o.label"
              :value="o.value"
            />
          </el-select>
          <div v-else-if="field.range" class="bm-main-image__date-range">
            <input
              v-model="addTime[0]"
              type="date"
              class="bm-main-image__date-input"
            />
            <span>—</span>
            <input
              v-model="addTime[1]"
              type="date"
              class="bm-main-image__date-input"
            />
          </div>
          <el-select
            v-else-if="
              field.key === 'group_id' || field.key === 'child_group_id'
            "
            v-model="filterValues[field.key]"
            class="bm-main-image__filter-select"
            @change="field.key === 'group_id' && onGroupChange()"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="o in optionsFor(field.key)"
              :key="o.value"
              :label="o.label"
              :value="o.value"
            />
          </el-select>
          <input
            v-else
            v-model="filterValues[field.key]"
            :placeholder="field.placeholder"
          />
        </div>
        <footer>
          <div>
            <button @click="previewBatch">查询</button>
            <button class="plain" @click="reset">重置</button>
          </div>
        </footer>
      </section>
      <section v-else class="bm-main-image__picked">
        <button @click="openSelector">选择商品</button>
        <span>{{
          selected.length
            ? "已选择 " + selected.length + " 个商品"
            : "请先选择需要修改的商品"
        }}</span>
      </section>
      <section class="bm-main-image__methods">
        <header>
          <p></p>
          修改内容
        </header>
        <div class="bm-main-image__methods-wrapper">
          <article v-for="method in methods" :key="method.id">
          <el-checkbox
            :value="form.selectedMethod === method.id"
            @change="onMethodChange(method.id)"
            class="bm-main-image__method-name"
          >
            方式{{ method.id }}：{{ method.name }}
          </el-checkbox>
          <div class="bm-main-image__method-content">
            <!-- 方式1：预览手动修改 -->
            <template v-if="method.id === 1">
              <span style="color: #909399">预览时可手动调整每个商品的主图</span>
            </template>

            <!-- 方式2：删除主图 -->
            <template v-else-if="method.id === 2">
              <el-checkbox-group
                v-model="form.deletePositions"
                :disabled="form.selectedMethod !== method.id"
              >
                <el-checkbox label="delete_1">第1张</el-checkbox>
                <el-checkbox label="delete_2">第2张</el-checkbox>
                <el-checkbox label="delete_3">第3张</el-checkbox>
                <el-checkbox label="delete_4">第4张</el-checkbox>
                <el-checkbox label="delete_5">第5张</el-checkbox>
                <el-checkbox label="delete_last">末尾</el-checkbox>
              </el-checkbox-group>
            </template>

            <!-- 方式3：添加主图 -->
            <template v-else-if="method.id === 3">
              <div class="bm-main-image__inline">
                <button
                  class="upload-box"
                  :class="{ 'is-disabled': form.selectedMethod !== method.id }"
                  @click="openImageUpload('add')"
                  :disabled="form.selectedMethod !== method.id"
                >
                  <span>+</span>
                  <small>上传图片</small>
                </button>
                <div v-if="form.addImages.length" class="selected-images">
                  <div
                    v-for="(img, idx) in form.addImages"
                    :key="idx"
                    class="image-item"
                  >
                    <img :src="img" alt="" />
                    <button
                      class="remove-img"
                      @click="form.addImages.splice(idx, 1)"
                      :disabled="form.selectedMethod !== method.id"
                    >
                      <i class="el-icon-close"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="bm-main-image__inline" style="margin-top: 10px">
                <span>插入位置：</span>
                <el-select
                  v-model="form.addPosition"
                  :disabled="form.selectedMethod !== method.id"
                  style="width: 200px"
                >
                  <el-option label="追加到末尾" value="append" />
                  <el-option label="第1张主图前" value="before_1" />
                  <el-option label="第2张主图前" value="before_2" />
                  <el-option label="第3张主图前" value="before_3" />
                  <el-option label="第4张主图前" value="before_4" />
                  <el-option label="第5张主图前" value="before_5" />
                </el-select>
              </div>
            </template>

            <!-- 方式4：主图替换 -->
            <template v-else-if="method.id === 4">
              <div class="replace-images-grid">
                <div v-for="i in 5" :key="i" class="replace-image-slot">
                  <label>第{{ i }}张</label>
                  <button
                    class="upload-box small"
                    :class="{ 'is-disabled': form.selectedMethod !== method.id }"
                    @click="openImageUpload('replace', i)"
                    :disabled="form.selectedMethod !== method.id"
                  >
                    <img v-if="form.replaceImages[i-1]" :src="form.replaceImages[i-1]" alt="" />
                    <template v-else>
                      <span>+</span>
                      <small>上传</small>
                    </template>
                  </button>
                  <button
                    v-if="form.replaceImages[i-1]"
                    class="remove-btn"
                    @click="form.replaceImages.splice(i-1, 1, '')"
                    :disabled="form.selectedMethod !== method.id"
                  >
                    删除
                  </button>
                </div>
              </div>
            </template>

            <!-- 方式5：将当前首图移到第x位 -->
            <template v-else-if="method.id === 5">
              <div class="bm-main-image__inline">
                <span>将当前首图移到第</span>
                <el-input-number
                  class="price-number-input"
                  v-model="form.moveFirstToPosition"
                  :disabled="form.selectedMethod !== method.id"
                  :min="2"
                  :max="10"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  placeholder="X"
                />
                <span>位</span>
              </div>
            </template>

            <!-- 方式6：将第x张设为首图 -->
            <template v-else-if="method.id === 6">
              <div class="bm-main-image__inline">
                <span>将第</span>
                <el-input-number
                  class="price-number-input"
                  v-model="form.setAsFirstPosition"
                  :disabled="form.selectedMethod !== method.id"
                  :min="2"
                  :max="10"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  placeholder="X"
                />
                <span>张设为首图</span>
              </div>
            </template>

            <!-- 方式7：随机打乱 -->
            <template v-else-if="method.id === 7">
              <el-radio-group
                v-model="form.shuffleMode"
                :disabled="form.selectedMethod !== method.id"
              >
                <el-radio label="keep_first">首图不变位置</el-radio>
                <el-radio label="shuffle_all">首图改变位置</el-radio>
                <el-radio label="keep_last">尾图位置不变，其他位置随机打乱</el-radio>
              </el-radio-group>
            </template>

            <!-- 方式8：最低价SKU图替换首张主图 -->
            <template v-else-if="method.id === 8">
              <span style="color: #909399">选择第一个低价SKU图，如果未有SKU图则不替换</span>
            </template>
          </div>
        </article>
        </div>
      </section>
      <section v-if="preview" class="bm-main-image__preview">
        <header>
          预览：共
          <b>{{ preview.product_count || preview.total || previewGoods.length || 0 }}</b>
          个商品，跳过
          <b>{{ preview.skipped_product_count || preview.skipped_product_count_total || 0 }}</b>
          个商品，失败
          <b>{{ preview.failed_product_count || preview.failed_count || 0 }}</b>
          个商品
        </header>
        <table>
          <thead>
            <tr>
              <th>商品信息</th>
              <th>主图预览（方式1 拖拽可以设置顺序）</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in previewGoods"
              :key="String(item.product_id || index)"
              :class="{ 'is-excluded': excludedProductIds.includes(String(item.product_id)) }">
              <td>
                <el-image
                  class="bm-main-image__image"
                  :src="imageOf(item)"
                  fit="cover"
                  :preview-src-list="[imageOf(item)]" />
                <div>
                  <p>{{ item.title || item.product_title }}</p>
                  <div class="preview-meta">
                    <small>商品ID：{{ item.product_id }}</small>
                    <small>来源ID：{{ item.source_product_id || '无数据' }}</small>
                    <small>数据源：{{ sourceLabel(item.source_web) }}</small>
                  </div>
                </div>
              </td>
              <td class="images-cell">
                <!-- 方式1：预览手动修改模式 - 显示操作按钮 -->
                <div v-if="form.selectedMethod === 1 && item.product_id">
                  <draggable
                    :value="getEditingImages(item.product_id)"
                    @input="updateEditingImages(item.product_id, $event)"
                    class="detail-images-preview"
                    :options="{ animation: 200 }"
                    @start="onDragStart(item.product_id)"
                    @end="onDragEnd(item.product_id)"
                  >
                    <div
                      v-for="(img, idx) in getEditingImages(item.product_id)"
                      :key="idx"
                      class="image-preview-item"
                      :title="'拖拽可以设置顺序'"
                    >
                      <el-image
                        :src="img.url"
                        fit="cover"
                        :preview-src-list="getEditingImages(item.product_id).map((i) => i.url)"
                        :initial-index="idx"
                        style="width: 100%; height: 100%; cursor: move"
                      >
                        <div slot="placeholder" class="image-loading">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                      <div class="image-actions-overlay">
                        <button
                          @click.stop="replaceImageInline(item.product_id, idx)"
                          class="icon-btn-overlay"
                          title="替换"
                        >
                          <i class="el-icon-refresh"></i>
                        </button>
                        <button
                          @click.stop="deleteImageInline(item.product_id, idx)"
                          class="icon-btn-overlay"
                          :disabled="getEditingImages(item.product_id).length <= 1"
                          title="删除"
                        >
                          <i class="el-icon-delete"></i>
                        </button>
                      </div>
                    </div>
                    <div
                      class="image-preview-item add-image"
                      @click="addNewImageInline(item.product_id)"
                      title="添加图片"
                    >
                      <span class="add-icon">+</span>
                    </div>
                  </draggable>
                </div>
                <!-- 其他方式：显示带标记的预览 -->
                <div v-else>
                  <div v-if="item.main_images && item.main_images.length" class="detail-images-preview">
                    <div
                      v-for="(img, idx) in item.main_images"
                      :key="idx"
                      class="image-preview-item"
                      :class="{
                        'image-added': img.change_type === 'added',
                        'image-replaced': img.change_type === 'replaced',
                        'image-moved': img.change_type === 'moved',
                        'image-deleted': img.change_type === 'deleted',
                      }"
                    >
                      <el-image
                        :src="img.url"
                        fit="cover"
                        :preview-src-list="item.main_images.filter(i => i.change_type !== 'deleted').map((i) => i.url)"
                        :initial-index="getPreviewIndexForImages(item.main_images, idx)"
                        style="width: 100%; height: 100%"
                      >
                        <div slot="placeholder" class="image-loading">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                      <div v-if="img.change_type === 'added'" class="change-badge badge-added">
                        新增
                      </div>
                      <div v-if="img.change_type === 'replaced'" class="change-badge badge-replaced">
                        替换
                      </div>
                      <div v-if="img.change_type === 'moved'" class="change-badge badge-moved">
                        移动
                      </div>
                      <div v-if="img.change_type === 'deleted'" class="change-badge badge-deleted">
                        已删除
                      </div>
                      <div v-if="img.change_type === 'deleted'" class="deleted-overlay"></div>
                    </div>
                  </div>
                  <div v-if="!item.main_images || item.main_images.length === 0" style="color: #999">
                    无主图
                  </div>
                </div>
              </td>
              <td class="status-cell">
                <span v-if="item.is_modified" style="color: #52c41a">将修改</span>
                <span v-else style="color: #999">无变化</span>
              </td>
              <td class="action-cell">
                <button
                  v-if="form.selectedMethod === 1"
                  @click="saveProductImages(item.product_id)"
                  :disabled="savingImages || !hasChanges(item.product_id)"
                  class="btn-save-action"
                >
                  {{ savingImages ? '保存中...' : '保存' }}
                </button>
                <button
                  v-if="!excludedProductIds.includes(String(item.product_id))"
                  @click="toggleExclude(item)">
                  排除
                </button>
                <button
                  v-else
                  class="restore"
                  @click="toggleExclude(item)">
                  恢复
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="bm-main-image__pagination">
          <button :disabled="previewPage.page <= 1" @click="previewBatchPage(previewPage.page - 1)">
            上一页
          </button>
          <span>{{ previewPage.page }} / {{ Math.max(1, Math.ceil(previewPage.total / previewPage.limit)) }}</span>
          <button
            :disabled="previewPage.page >= Math.max(1, Math.ceil(previewPage.total / previewPage.limit))"
            @click="previewBatchPage(previewPage.page + 1)">
            下一页
          </button>
          <select v-model.number="previewPage.limit" @change="previewBatch">
            <option :value="10">10条/页</option>
            <option :value="20">20条/页</option>
            <option :value="50">50条/页</option>
          </select>
        </div>
      </section>
    </main>
    <footer v-if="mode" class="bm-main-image__bottom">
      <button class="preview" @click="previewBatch" :disabled="previewLoading">
        {{ previewLoading ? '查询中...' : '修改内容预览' }}
      </button>
      <button class="start" @click="createBatch" :disabled="submitting || !canCreate" title="点击预览检查无误后，再点击开始批量修改">
        {{ submitting ? '提交中...' : '开始批量修改' }}
      </button>
    </footer>
    <div v-if="selecting" class="bm-main-image__mask">
      <div class="bm-main-image__select-modal">
        <header>
          <strong>选择修改商品</strong>
          <button @click="selecting = false">×</button>
        </header>
        <nav>
          <button :class="{ active: selectorTab === 'all' }" @click="switchSelectorTab('all')">选择商品</button>
          <button :class="{ active: selectorTab === 'selected' }" @click="switchSelectorTab('selected')">已选择</button>
        </nav>
        <div class="bm-main-image__selector-toolbar">
          <div class="bm-main-image__select-filter">
            <el-select
              v-model="selectorFilters.group_id"
              popper-class="bm-main-image__select-popper"
              class="bm-main-image__group-select"
              @change="loadSelectorGroups">
              <el-option label="全部分组" value="" />
              <el-option v-for="g in groupList" :key="g.id" :label="g.name || g.group_name" :value="g.id" />
            </el-select>
            <el-select
              v-model="selectorFilters.child_group_id"
              popper-class="bm-main-image__select-popper"
              class="bm-main-image__group-select"
              @change="loadGoods(1)">
              <el-option label="全部子分组" value="" />
              <el-option v-for="g in selectorChildGroups" :key="g.id" :label="g.name || g.group_name" :value="g.id" />
            </el-select>
            <input v-model="selectorFilters.source_product_id" placeholder="来源ID" />
            <input v-model="selectorFilters.keyword" placeholder="商品标题" />
            <button @click="loadGoods(1)">查询</button>
          </div>
          <div class="bm-main-image__selector-pagination">
            <button :disabled="selectorPage.page <= 1" @click="loadGoods(selectorPage.page - 1)">上一页</button>
            <span>{{ selectorPage.page }} / {{ Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit)) }}</span>
            <button
              :disabled="selectorPage.page >= Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit))"
              @click="loadGoods(selectorPage.page + 1)">
              下一页
            </button>
            <el-select
              v-model="selectorPage.limit"
              popper-class="bm-main-image__select-popper"
              class="bm-main-image__page-size"
              @change="loadGoods(1)">
              <el-option v-for="n in [10, 20, 50]" :key="n" :label="n + '条/页'" :value="n" />
            </el-select>
          </div>
          <label class="bm-main-image__select-all">
            <el-checkbox :value="selectorPageAllSelected" @change="togglePageGoods" />
            全选
          </label>
        </div>
        <main>
          <button
            v-for="g in displayedGoods"
            :key="g.product_id"
            :class="{ selected: selected.includes(String(g.product_id)) }"
            @click="toggleGood(g.product_id)">
            <el-checkbox
              :value="selected.includes(String(g.product_id))"
              @click.native.stop
              @change="toggleGood(g.product_id)" />
            <img :src="imageOf(g)" alt="商品主图" />
            <span>{{ g.title || g.product_title }}</span>
            <small>{{ priceRange(g) }}</small>
          </button>
        </main>
        <footer>
          <span>已选 {{ selected.length }} 个商品</span>
          <button class="plain" @click="selecting = false">取消</button>
          <button @click="selecting = false">确定</button>
        </footer>
      </div>
    </div>
    <image-selector-dialog
      :visible.sync="imageSelector.visible"
      :type="imageSelector.type"
      :index="imageSelector.index"
      :product-id="imageSelector.productId"
      :multiple="imageSelector.multiple"
      :disable-upload="imageSelector.disableUpload"
      image-source="main_sku"
      @select="handleImageSelected"
    />
  </section>
</template>

<script>
import ImageSelectorDialog from './components/ImageSelectorDialog.vue'
import { cloudProductGroups, cloudProductList } from '@/api/main/ucenter'
import { previewCloudMainImageBatch, createCloudMainImageBatch, saveProductMainImages } from '@/api/main/cloudBatchEdit'
import draggable from 'vuedraggable'

export default {
  name: 'BatchModifyMainImage',
  components: { ImageSelectorDialog, draggable },
  data() {
    return {
      mode: 'range',
      filterValues: {
        group_id: '',
        child_group_id: '',
        source_product_id: '',
        sku_status: '',
        sku_mark_status: '',
        ai_title_status: '',
        source_web: ''
      },
      addTime: ['', ''],
      selected: [],
      selectedGoods: [],
      preview: null,
      previewGoods: [],
      previewPage: {
        page: 1,
        limit: 20,
        total: 0
      },
      previewKey: '',
      previewLoading: false,
      savingImages: false,
      excludedProductIds: [],
      submitting: false,
      selecting: false,
      selectorTab: 'all',
      selectorFilters: {
        group_id: '',
        child_group_id: '',
        source_product_id: '',
        keyword: ''
      },
      selectorPage: {
        page: 1,
        limit: 20,
        total: 0
      },
      selectorGoods: [],
      selectorChildGroups: [],
      // 拖拽编辑相关
      inlineEditingImagesMap: {},
      dragOriginalOrder: {},
      methods: [
        { id: 1, name: '预览手动修改' },
        { id: 2, name: '删除主图' },
        { id: 3, name: '添加主图' },
        { id: 4, name: '主图替换' },
        { id: 5, name: '将当前首图移到第x位' },
        { id: 6, name: '将第x张设为首图' },
        { id: 7, name: '随机打乱' },
        { id: 8, name: '最低价SKU图替换首张主图' }
      ],
      form: {
        selectedMethod: 1,
        deletePositions: [],
        addImages: [],
        addPosition: 'append',
        replaceImages: ['', '', '', '', ''],
        moveFirstToPosition: 2,
        setAsFirstPosition: 2,
        shuffleMode: 'keep_first'
      },
      imageSelector: {
        visible: false,
        type: '',
        index: null,
        productId: null,
        multiple: false,
        disableUpload: false
      },
      fields: [
        { key: 'group_id', label: '分组' },
        { key: 'child_group_id', label: '子分组' },
        { key: 'source_web', label: '来源平台', select: true },
        { key: 'source_product_id', label: '来源商品ID', placeholder: '请输入来源商品ID' },
        { key: 'created_time', label: '添加时间', range: true },
        { key: 'sku_status', label: 'SKU替换状态', select: true },
        { key: 'sku_mark_status', label: 'SKU标记状态', select: true },
        { key: 'ai_title_status', label: 'AI标题状态', select: true }
      ],
      statusOptions: {
        source_web: [],
        sku_status: [
          { label: '未替换', value: 0 },
          { label: '已替换', value: 1 }
        ],
        sku_mark_status: [
          { label: '未标记', value: 0 },
          { label: '已标记', value: 1 }
        ],
        ai_title_status: [
          { label: '未生成', value: 0 },
          { label: '已生成', value: 1 }
        ]
      },
      groupList: [],
      childGroupList: []
    }
  },
  computed: {
    displayedGoods() {
      if (this.selectorTab === 'selected') {
        const s = (this.selectorPage.page - 1) * this.selectorPage.limit
        return this.selectedGoods.slice(s, s + this.selectorPage.limit)
      }
      return this.selectorGoods
    },
    selectorPageAllSelected() {
      if (!this.displayedGoods.length) return false
      return this.displayedGoods.every(g => this.selected.includes(String(g.product_id)))
    },
    canCreate() {
      return !!this.preview && this.previewKey === this.payloadKey()
    }
  },
  methods: {
    onMethodChange(methodId) {
      this.form.selectedMethod = this.form.selectedMethod === methodId ? null : methodId
      this.invalidate()
    },
    openImageUpload(type, index) {
      // 类型与方式ID的映射关系
      const typeMethodMap = {
        add: 3,
        replace: 4
      }

      const requiredMethod = typeMethodMap[type]
      if (this.form.selectedMethod !== requiredMethod) {
        this.$message.warning('请选择当前方式再选择图片')
        return
      }

      // 方式3添加主图允许多选和上传
      // 方式4替换主图单选允许上传
      this.imageSelector = {
        visible: true,
        type: type,
        index: index,
        productId: null,
        multiple: type === 'add',
        disableUpload: false
      }
    },
    handleImageSelected(urls) {
      const { type, index, productId } = this.imageSelector

      if (type === 'add') {
        // 方式3：添加主图
        this.form.addImages.push(...urls)
      } else if (type === 'replace') {
        // 方式4：主图替换
        if (index !== null && index >= 1 && index <= 5) {
          this.$set(this.form.replaceImages, index - 1, urls[0])
        }
      } else if (type === 'inline_replace') {
        // 内联替换：方式1中的替换操作
        this.ensureEditingImages(productId)
        const img = this.inlineEditingImagesMap[productId][index]
        const oldUrl = img.url
        img.url = urls[0]

        // 如果有 id，说明是替换已有图片，状态为 2
        // 如果没有 id，说明是替换新增的图片，保持状态 4
        if (img.id) {
          img.status = 2 // 2=替换
        }

        // 更新 previewGoods 中的数据
        const itemIndex = this.previewGoods.findIndex(g => g.product_id === productId)
        if (itemIndex !== -1) {
          this.$set(this.previewGoods[itemIndex], 'main_images', JSON.parse(JSON.stringify(this.inlineEditingImagesMap[productId])))
          this.$set(this.previewGoods[itemIndex], 'is_modified', true)
        }

        this.$forceUpdate()
      } else if (type === 'inline_add') {
        // 内联新增：方式1中的添加操作
        this.ensureEditingImages(productId)

        // 添加新图片到末尾
        urls.forEach(url => {
          this.inlineEditingImagesMap[productId].push({
            url: url,
            sort: this.inlineEditingImagesMap[productId].length,
            status: 4, // 4=新增
            original_url: url
          })
        })

        // 更新 previewGoods 中的数据
        const itemIndex = this.previewGoods.findIndex(g => g.product_id === productId)
        if (itemIndex !== -1) {
          this.$set(this.previewGoods[itemIndex], 'main_images', JSON.parse(JSON.stringify(this.inlineEditingImagesMap[productId])))
          this.$set(this.previewGoods[itemIndex], 'is_modified', true)
        }

        this.$forceUpdate()
      }

      this.imageSelector.visible = false
    },
    switchMode(mode) {
      this.mode = mode
      this.preview = null
      this.previewPage.page = 1
      this.invalidate()
    },
    optionsFor(key) {
      if (key === 'group_id') {
        return this.groupList.map(i => ({ value: i.id, label: i.name || i.group_name }))
      }
      if (key === 'child_group_id') {
        return this.childGroupList.map(i => ({ value: i.id, label: i.name || i.group_name }))
      }
      return this.statusOptions[key] || []
    },
    onGroupChange() {
      const g = this.groupList.find(i => String(i.id) === String(this.filterValues.group_id))
      this.childGroupList = (g && g.child_groups) || []
      this.filterValues.child_group_id = ''
    },
    async loadGroups() {
      try {
        const r = await cloudProductGroups({ with_count: 0 })
        this.groupList = (r.data && (r.data.data || r.data)) || []
      } catch (e) {
        this.$message.error('请求失败，请稍后重试')
      }
    },
    buildQueryPayload() {
      const productFilter = { ...this.filterValues }
      if (this.addTime[0]) {
        productFilter.created_start = this.addTime[0]
      }
      if (this.addTime[1]) {
        productFilter.created_end = this.addTime[1]
      }
      if (this.mode === 'goods') {
        productFilter.product_ids = this.selected.map(String)
        productFilter.excluded_product_ids = this.excludedProductIds.map(String)
      }
      return {
        product_filter: productFilter,
        main_image_rule: {
          // TODO: 主图修改规则，待后续实现
        }
      }
    },
    payloadKey() {
      return JSON.stringify(this.buildPayload())
    },
    buildPayload() {
      const f = this.form

      // 构建商品过滤条件
      let productFilter = {}

      if (this.mode === 'goods' && this.selected.length > 0) {
        productFilter = {
          product_ids: this.selected.map(String)
        }
      } else {
        const ids = (f.productIds || '')
          .split(/[,，\r\n]+/)
          .map((v) => v.trim())
          .filter(Boolean)

        productFilter = {
          ...this.filterValues,
          product_ids: ids,
          excluded_product_ids: this.excludedProductIds.map(String),
          created_start: this.addTime[0] || '',
          created_end: this.addTime[1] || '',
          keyword: f.keyword || '',
        }
      }

      const p = {
        product_filter: productFilter,
        main_image_rule: this.buildMainImageRule(),
      }

      return p
    },
    buildMainImageRule() {
      const f = this.form
      if (!f.selectedMethod) return {}

      const rule = { method: f.selectedMethod }

      if (f.selectedMethod === 1) {
        // 方式1: 预览手动修改（无参数）
      } else if (f.selectedMethod === 2) {
        // 方式2: 删除主图
        // 将 "delete_1" 转换为数字 1，"delete_last" 转换为字符串 "delete_last"
        rule.delete_positions = (f.deletePositions || []).map(pos => {
          if (typeof pos === 'string') {
            if (pos === 'delete_last') {
              return 'delete_last' // 保持字符串，后端会处理
            } else if (pos.startsWith('delete_')) {
              return parseInt(pos.replace('delete_', ''))
            }
          }
          return parseInt(pos)
        }).filter(pos => {
          // 允许 "delete_last" 字符串或有效数字
          return pos === 'delete_last' || (!isNaN(pos) && pos > 0)
        })
      } else if (f.selectedMethod === 3) {
        // 方式3: 添加主图
        rule.add_images = (f.addImages || []).filter(url => url.trim())
        rule.add_position = f.addPosition || 'append'
      } else if (f.selectedMethod === 4) {
        // 方式4: 主图替换
        rule.replace_images = f.replaceImages || ['', '', '', '', '']
      } else if (f.selectedMethod === 5) {
        // 方式5: 将当前首图移到第X位
        rule.move_first_to_position = f.moveFirstToPosition
      } else if (f.selectedMethod === 6) {
        // 方式6: 将第X张设为首图
        rule.set_as_first_position = f.setAsFirstPosition
      } else if (f.selectedMethod === 7) {
        // 方式7: 随机打乱
        rule.shuffle_mode = f.shuffleMode || 'keep_first'
      } else if (f.selectedMethod === 8) {
        // 方式8: 最低价SKU图替换首张主图（无参数）
      }

      return rule
    },
    validate(isSubmit = false) {
      const p = this.buildPayload()

      if (this.mode === 'goods' && !p.product_filter.product_ids.length) {
        return '请选择商品'
      }

      if (!this.form.selectedMethod) {
        return '请选择一种修改方式'
      }

      if (isSubmit && this.form.selectedMethod === 1) {
        return '方式1仅支持预览，不支持批量修改'
      }

      // 验证各方式必填内容
      const f = this.form
      if (f.selectedMethod === 2) {
        // 方式2: 删除主图
        if (!f.deletePositions || f.deletePositions.length === 0) {
          return '请选择要删除的位置'
        }
      } else if (f.selectedMethod === 3) {
        // 方式3: 添加主图
        if (!f.addImages || f.addImages.filter(url => url.trim()).length === 0) {
          return '请至少上传一张图片'
        }
      } else if (f.selectedMethod === 4) {
        // 方式4: 主图替换
        const hasImage = f.replaceImages.some(url => url && url.trim())
        if (!hasImage) {
          return '请至少指定一张替换图片'
        }
      } else if (f.selectedMethod === 5) {
        // 方式5: 将当前首图移到第X位
        if (!f.moveFirstToPosition || f.moveFirstToPosition < 2 || f.moveFirstToPosition > 10) {
          return '目标位置必须在2-10之间'
        }
      } else if (f.selectedMethod === 6) {
        // 方式6: 将第X张设为首图
        if (!f.setAsFirstPosition || f.setAsFirstPosition < 2 || f.setAsFirstPosition > 10) {
          return '源位置必须在2-10之间'
        }
      }

      return ''
    },
    invalidate() {
      this.preview = null
      this.previewKey = ''
    },
    async previewBatch() {
      const error = this.validate();
      if (error) return this.$message.warning(error);

      // 检查payload是否发生变化，如果变化则重置页码为1
      const currentPayloadKey = this.payloadKey();
      if (this.previewKey && this.previewKey !== currentPayloadKey) {
        this.previewPage.page = 1;
      }

      this.previewLoading = true
      try {
        const payload = this.buildPayload();
        const r = await previewCloudMainImageBatch({
          ...payload,
          page: this.previewPage.page,
          limit: this.previewPage.limit
        })

        if (r.code === 200 || r.code === 0) {
          this.preview = {
            product_count: r.data.product_count || 0,
            total: r.data.total || 0,
          }
          this.previewGoods = r.data.list || []
          this.previewPage.total = r.data.total || 0
          this.previewKey = this.payloadKey()
        } else {
          throw new Error(r.msg || r.message || "预览失败")
        }
      } catch (e) {
        this.invalidate()
        this.$message.error(
          (e.response && e.response.data && (e.response.data.msg || e.response.data.message)) ||
            e.message ||
            '请求失败，请稍后重试'
        )
      } finally {
        this.previewLoading = false
      }
    },
    async previewBatchPage(page) {
      this.previewPage.page = page
      await this.previewBatch()
    },
    async createBatch() {
      if (!this.canCreate) return this.$message.warning('请先预览当前修改规则')

      const error = this.validate(true);
      if (error) return this.$message.warning(error);

      // 检查商品数量
      const totalProducts = this.previewPage?.total || 0
      if (totalProducts <= 0) {
        this.$message.warning('商品数小于0，请选择商品后点击修改预览')
        return
      }

      // 弹出确认提示
      try {
        await this.$confirm(`商品数${totalProducts}，是否开始修改？`, '确认修改', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        // 用户点击取消
        return
      }

      this.submitting = true
      try {
        const payload = this.buildPayload();
        const r = await createCloudMainImageBatch(payload)

        if (r.code === 200 || r.code === 0) {
          this.$message.success('批量修改任务已创建，请前往任务列表查看进度')
          this.$emit('back')
        } else {
          throw new Error(r.msg || r.message || '创建任务失败')
        }
      } catch (e) {
        this.$message.error(
          (e.response && e.response.data && (e.response.data.msg || e.response.data.message)) ||
            e.message ||
            '请求失败，请稍后重试'
        )
      } finally {
        this.submitting = false
      }
    },
    toggleExclude(item) {
      const id = String(item.product_id)
      const index = this.excludedProductIds.indexOf(id)
      if (!id || id === 'undefined' || id === 'null') return
      if (index < 0) {
        this.excludedProductIds.push(id)
      } else {
        this.excludedProductIds.splice(index, 1)
      }
      this.invalidate()
    },
    sourceLabel(value) {
      const labels = { 9: '星好货', 3: 'TB', 4: 'PDD', 2: '1688', 5: 'DY', 6: 'WX' }
      return labels[String(value)] || value || '未知'
    },
    reset() {
      this.filterValues = {
        group_id: '',
        child_group_id: '',
        source_product_id: '',
        sku_status: '',
        sku_mark_status: '',
        ai_title_status: '',
        source_web: ''
      }
      this.addTime = ['', '']
      this.excludedProductIds = []
      this.invalidate()
    },
    async openSelector() {
      this.selecting = true
      this.selectorTab = 'all'
      await this.loadGroups()
      this.loadSelectorGroups()
      await this.loadGoods(1)
    },
    loadSelectorGroups() {
      const g = this.groupList.find(i => String(i.id) === String(this.selectorFilters.group_id))
      this.selectorChildGroups = (g && g.child_groups) || []
      this.selectorFilters.child_group_id = ''
      this.loadGoods(1)
    },
    async loadGoods(page = 1) {
      try {
        const params = {
          page,
          page_size: this.selectorPage.limit,
          status: 1,
          ...this.selectorFilters
        }
        const r = await cloudProductList(params)
        const body = r.data && r.data.data ? r.data.data : r.data
        this.selectorGoods = body.list || body.data || []
        this.selectorPage.page = page
        this.selectorPage.total = Number(body.total || this.selectorGoods.length)
      } catch (e) {
        this.$message.error('加载商品失败')
      }
    },
    switchSelectorTab(tab) {
      this.selectorTab = tab
      if (tab === 'selected') {
        this.selectorPage.total = this.selectedGoods.length
        this.selectorPage.page = 1
      } else {
        this.loadGoods(1)
      }
    },
    toggleGood(productId) {
      const id = String(productId)
      const index = this.selected.indexOf(id)
      if (index > -1) {
        this.selected.splice(index, 1)
        this.selectedGoods = this.selectedGoods.filter(g => String(g.product_id) !== id)
      } else {
        this.selected.push(id)
        const good = this.selectorGoods.find(g => String(g.product_id) === id)
        if (good) {
          this.selectedGoods.push(good)
        }
      }
    },
    togglePageGoods(checked) {
      this.displayedGoods.forEach(g => {
        const id = String(g.product_id)
        if (!id || id === 'undefined' || id === 'null') return
        if (checked && !this.selected.includes(id)) {
          this.selected.push(id)
          this.selectedGoods.push(g)
        }
        if (!checked) {
          const i = this.selected.indexOf(id)
          if (i >= 0) this.selected.splice(i, 1)
          this.selectedGoods = this.selectedGoods.filter(x => String(x.product_id) !== id)
        }
      })
    },
    imageOf(item) {
      return item.main_image || item.image || item.cover_image || ''
    },
    priceRange(good) {
      const min = good.min_price ?? good.price_min ?? good.price
      const max = good.max_price ?? good.price_max ?? min
      return min === undefined || min === null ? '价格待定' : `¥${min}~¥${max}`
    },
    getPreviewIndexForImages(images, currentIndex) {
      // 计算点击预览时的索引，需要排除已删除的图片
      let previewIndex = 0
      for (let i = 0; i < currentIndex; i++) {
        if (images[i].change_type !== 'deleted') {
          previewIndex++
        }
      }
      return previewIndex
    },
    // 拖拽相关方法
    ensureEditingImages(productId) {
      if (!this.inlineEditingImagesMap[productId]) {
        const item = this.previewGoods.find(g => g.product_id === productId)
        if (item && item.main_images) {
          // 深拷贝，并确保每个图片都有完整的数据（id, url, sort, original_sort）
          const images = JSON.parse(JSON.stringify(item.main_images))
          images.forEach((img, index) => {
            // 保留原始 id（如果存在）
            img.id = img.id || null
            img.original_sort = img.sort !== undefined ? img.sort : index
            img.original_url = img.url
            img.status = 1 // 1=未变化
          })
          this.$set(this.inlineEditingImagesMap, productId, images)
        }
      }
    },
    getEditingImages(productId) {
      this.ensureEditingImages(productId)
      const images = this.inlineEditingImagesMap[productId] || []
      // 过滤掉已删除的图片（status=3）
      return images.filter(img => img.status !== 3)
    },
    updateEditingImages(productId, newImages) {
      this.$set(this.inlineEditingImagesMap, productId, newImages)
    },
    onDragStart(productId) {
      this.ensureEditingImages(productId)
      // 保存拖拽前的原始顺序（通过 url 来标识）
      const images = this.inlineEditingImagesMap[productId]
      if (images) {
        this.dragOriginalOrder[productId] = images.map(img => img.url)
      }
    },
    onDragEnd(productId) {
      // 拖拽结束后，重新计算状态
      const images = this.inlineEditingImagesMap[productId]

      if (images) {
        // 重新设置 sort 并判断是否移动
        images.forEach((img, newIndex) => {
          const oldSort = img.original_sort !== undefined ? img.original_sort : img.sort

          // 如果位置发生变化且不是新增或替换的图片，标记为移动
          if (img.status === 1 && oldSort !== newIndex) {
            img.status = 5 // 5=移动
          }

          img.sort = newIndex
        })

        // 更新预览数据
        this.$set(this.inlineEditingImagesMap, productId, images)

        // 同时更新 previewGoods 中的数据
        const itemIndex = this.previewGoods.findIndex(g => g.product_id === productId)
        if (itemIndex !== -1) {
          this.$set(this.previewGoods[itemIndex], 'main_images', JSON.parse(JSON.stringify(images)))
          this.$set(this.previewGoods[itemIndex], 'is_modified', true)
        }

        this.$forceUpdate()
      }
    },
    // 替换图片
    replaceImageInline(productId, index) {
      this.imageSelector = {
        visible: true,
        type: 'inline_replace',
        index: index,
        productId: productId,
        multiple: false,
        disableUpload: false
      }
    },
    // 删除图片
    deleteImageInline(productId, index) {
      const images = this.getEditingImages(productId)
      if (images.length <= 1) {
        this.$message.warning('主图至少保留一张！')
        return
      }
      this.$confirm('确定删除这张图片？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.ensureEditingImages(productId)
          const img = this.inlineEditingImagesMap[productId][index]

          // 如果有 id，说明是删除已有图片，标记为删除状态 3
          // 如果没有 id，说明是删除新增的图片，直接从数组中移除
          if (img.id) {
            img.status = 3 // 3=删除
            // 不从数组中移除，保留以便后端处理
          } else {
            // 新增的图片直接删除
            this.inlineEditingImagesMap[productId].splice(index, 1)
          }

          // 更新 previewGoods 中的数据
          const itemIndex = this.previewGoods.findIndex(g => g.product_id === productId)
          if (itemIndex !== -1) {
            this.$set(this.previewGoods[itemIndex], 'main_images', JSON.parse(JSON.stringify(this.inlineEditingImagesMap[productId])))
            this.$set(this.previewGoods[itemIndex], 'is_modified', true)
          }

          this.$forceUpdate()
        })
        .catch(() => {})
    },
    // 添加新图片
    addNewImageInline(productId) {
      this.imageSelector = {
        visible: true,
        type: 'inline_add',
        index: null,
        productId: productId,
        multiple: true,
        disableUpload: false
      }
    },
    // 检查是否有修改
    hasChanges(productId) {
      const images = this.inlineEditingImagesMap[productId]
      if (!images) {
        return false
      }
      // 检查是否有任何非状态1（未变化）的图片
      return images.some(img => img.status !== 1)
    },
    // 保存商品主图修改
    async saveProductImages(productId) {
      const images = this.inlineEditingImagesMap[productId]
      if (!images) {
        return
      }

      // 过滤出未删除的图片数量
      const validImages = images.filter(img => img.status !== 3)
      if (validImages.length === 0) {
        this.$message.warning('主图至少保留一张！')
        return
      }

      this.savingImages = true
      try {
        // 构建保存数据：传递完整的图片信息，包括 id、url、sort、status
        // status: 1=未变化, 2=替换, 3=删除, 4=新增, 5=移动
        // 重新计算 sort：未删除的图片按顺序分配 0, 1, 2...
        let newSort = 0
        const imageData = images.map((img) => {
          const data = {
            id: img.id || null,
            url: img.url,
            status: img.status || 1
          }

          // 如果是删除状态，保留原 sort
          if (img.status === 3) {
            data.sort = img.sort !== undefined ? img.sort : 0
          } else {
            // 未删除的图片按顺序分配新的 sort
            data.sort = newSort
            newSort++

            // 如果 sort 改变了，且当前状态是未变化(1)，则改为移动(5)
            if (img.status === 1 && img.original_sort !== undefined && img.original_sort !== data.sort) {
              data.status = 5
            }
          }

          return data
        })

        const r = await saveProductMainImages(productId, { images: imageData })
        if (r.code === 200 || r.code === 0) {
          this.$message.success('保存成功')
          // 清除编辑状态
          this.$delete(this.inlineEditingImagesMap, productId)

          // 更新预览列表中对应商品的数据（从后端重新获取该商品的最新主图数据）
          const itemIndex = this.previewGoods.findIndex(g => g.product_id === productId)
          if (itemIndex !== -1) {
            // 重新加载该商品的主图数据
            const updatedImages = validImages.map((img, index) => ({
              id: img.id,
              url: img.url,
              sort: index
            }))
            this.$set(this.previewGoods[itemIndex], 'main_images', updatedImages)
            this.$set(this.previewGoods[itemIndex], 'is_modified', false)
            this.$set(this.previewGoods[itemIndex], 'main_image', validImages[0]?.url || '')
          }
        } else {
          throw new Error(r.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.savingImages = false
      }
    }
  },
  mounted() {
    this.loadGroups()
  }
}
</script>

<style scoped>
.bm-main-image__repeat-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  width: 100%;
}

/* 详情图预览容器 */
.detail-images-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 0;
}

/* 图片预览项 */
.image-preview-item {
  position: relative;
  width: 80px;
  height: 80px;
  border: 2px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s;
  flex-shrink: 0;
}

.image-preview-item:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 变化标识 */
.change-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  padding: 2px 6px;
  border-radius: 2px;
  font-size: 10px;
  color: #fff;
  font-weight: 500;
  z-index: 2;
}

.badge-added {
  background-color: #52c41a;
}

.badge-replaced {
  background-color: #1890ff;
}

.badge-moved {
  background-color: #faad14;
}

.badge-deleted {
  background-color: #ff4d4f;
}

/* 图片变化样式 */
.image-added {
  border-color: #52c41a;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.2);
}

.image-replaced {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.image-moved {
  border-color: #faad14;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
}

.image-deleted {
  border-color: #ff4d4f;
  opacity: 0.6;
}

/* 删除图片遮罩 */
.deleted-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.image-deleted::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 10%;
  right: 10%;
  height: 2px;
  background-color: #ff4d4f;
  transform: translateY(-50%) rotate(-15deg);
  z-index: 2;
}

/* 图片加载中 */
.image-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  color: #999;
}

.image-loading i {
  font-size: 20px;
}

/* 图片操作按钮遮罩层 */
.image-preview-item:hover .image-actions-overlay {
  opacity: 1;
}

.image-actions-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 0;
  opacity: 0;
  transition: opacity 0.2s;
}

.image-actions-overlay .icon-btn-overlay {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 20px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.image-actions-overlay .icon-btn-overlay:hover:not(:disabled) {
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.image-actions-overlay .icon-btn-overlay:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* 添加图片按钮 */
.image-preview-item.add-image {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #d9d9d9;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.2s;
}

.image-preview-item.add-image:hover {
  border-color: #1677ff;
  background: #f0f7ff;
}

.add-icon {
  font-size: 24px;
  color: #999;
}

.image-preview-item.add-image:hover .add-icon {
  color: #1677ff;
}

/* 表格单元格样式 */
.images-cell {
  vertical-align: top;
  padding: 12px !important;
}

.status-cell {
  text-align: center;
  vertical-align: middle;
}

.bm-main-image__repeat-row .bm-main-image__select {
  min-width: 160;
}

@media (max-width: 768px) {
  .bm-main-image__repeat-row {
    align-items: flex-start;
    flex-direction: column;
  }
}

.bm-main-image {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  overflow-x: hidden;
  background: #f5f6f8;
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
}

.bm-main-image__preview tr:nth-child(even) {
  background: #fcfcfd;
}

.bm-main-image__preview tr:hover {
  background: #f0f7ff;
}

.bm-main-image__preview tr.is-excluded {
  background: #e5e5e5;
  color: #777;
}

.bm-main-image button,
.bm-main-image input,
.bm-main-image select,
.bm-main-image textarea {
  font: inherit;
}

.bm-main-image button {
  cursor: pointer;
}

.bm-main-image__head {
  background: #fff;
  border-bottom: 1px solid #e0e0ec;
  padding: 10px 20px 0;
}

.bm-main-image__crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #999;
}

.bm-main-image__crumb button {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
}

.bm-main-image__crumb a {
  margin-left: auto;
  color: #1677ff;
}

.bm-main-image h1 {
  margin: 12px 0 8px;
  font: 600 18px 'Noto Serif SC', serif;
}

.bm-main-image__head nav {
  display: flex;
  gap: 22px;
}

.bm-main-image__head nav button {
  padding: 9px 6px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 13px;
}

.bm-main-image__head nav button.active {
  border-bottom-color: #c8443c;
  color: #c8443c;
  font-weight: 600;
}

.bm-main-image__body {
  padding: 14px 20px 82px;
}

.bm-main-image__filter {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px 14px;
  padding: 14px 16px 10px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-main-image__field label {
  display: block;
  margin-bottom: 4px;
  color: #666;
  font-size: 10px;
}

.bm-main-image__field input,
.bm-main-image__field select,
.bm-main-image__range input,
.bm-main-image__method-content input,
.bm-main-image__method-content select,
.bm-main-image__method-content textarea,
.bm-main-image__options select,
.bm-main-image__select-filter input {
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
}

.bm-main-image__range {
  display: flex;
  align-items: center;
  gap: 5px;
}

.bm-main-image__range span {
  color: #999;
}

.bm-main-image__filter footer {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-top: 9px;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
}

.bm-main-image__filter footer span {
  margin-right: auto;
  color: #999;
}

.bm-main-image__filter b {
  color: #1677ff;
}

.bm-main-image__filter button,
.bm-main-image__picked button,
.bm-main-image__small-modal footer button,
.bm-main-image__select-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #c8443c;
  color: #fff;
  font-size: 12px;
}

.bm-main-image__filter .plain,
.bm-main-image__small-modal .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

.bm-main-image__picked,
.bm-main-image__fail,
.bm-main-image__options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 14px;
  padding: 10px 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-main-image__picked button {
  background: #1677ff;
}

.bm-main-image__picked span {
  color: #1677ff;
}

.bm-main-image__fail {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #1a1a2e;
}

.bm-main-image__methods {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-main-image__methods > header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  background: #f5f0e8;
  font-size: 12px;
  font-weight: 600;
}

.bm-main-image__methods > header p {
  display: inline-block;
  width: 3px;
  height: 14px;
  margin-right: 7px;
  border-radius: 2px;
  background: #c8443c;
  vertical-align: middle;
}

.bm-main-image__methods article {
  padding: 12px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-main-image__methods article:last-child {
  border-bottom: 0;
}

.bm-main-image__method-name {
  font-weight: 500;
}

.bm-main-image__method-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0 22px;
  color: #666;
}

.bm-main-image__method-content input {
  width: 190px;
}

.bm-main-image__method-content input.long {
  width: 360px;
}

.bm-main-image__method-content textarea {
  width: 360px;
  height: 62px;
  resize: vertical;
}

.bm-main-image__method-content select {
  width: 145px;
}

.bm-main-image__method-content small {
  color: #999;
  font-size: 10px;
}

.bm-main-image__method-content .warning {
  color: #c8443c;
}

.bm-main-image__replace {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-main-image__replace button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #91caff;
  border-radius: 4px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 11px;
}

.bm-main-image__options {
  background: #f5f0e8;
}

.bm-main-image__options span {
  margin-left: auto;
}

.bm-main-image__options select {
  width: 150px;
}

.bm-main-image__preview {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-main-image__preview header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-main-image__preview header b {
  color: #1677ff;
}

.bm-main-image__preview header button {
  float: right;
  border: 0;
  background: none;
  color: #c8443c;
}

.bm-main-image__preview table {
  width: 100%;
  border-collapse: collapse;
}

.bm-main-image__preview th {
  padding: 8px 12px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}

.bm-main-image__preview tr {
  border-bottom: 1px solid #f0f0f0;
}

.bm-main-image__preview td {
  padding: 10px 12px;
  font-size: 11px;
}

.bm-main-image__head nav .mode-range {
  color: #1677ff;
}

.bm-main-image__head nav .mode-goods {
  color: #722ed1;
}

.bm-main-image__head nav .mode-range.active {
  border-bottom-color: #1677ff;
  background: #f0f7ff;
}

.bm-main-image__head nav .mode-goods.active {
  border-bottom-color: #722ed1;
  background: #f9f0ff;
  color: #722ed1;
}

.bm-main-image__preview .title-col,
.bm-main-image__preview .title-cell,
.bm-main-image__preview .action-cell {
  text-align: center;
  vertical-align: middle;
}

.bm-main-image__preview td:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px;
}

.bm-main-image__preview p {
  margin: 3px 0 0;
}

.bm-main-image__preview small {
  line-height: 16px;
  color: #999;
}

.bm-main-image__preview .preview-meta {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  margin-top: 4px;
  white-space: nowrap;
  line-height: 16px;
}

.bm-main-image__preview .preview-meta small {
  display: inline;
  margin: 0;
}

.bm-main-image__sku-list .sku-error {
  color: #f56c6c;
}

.bm-main-image__preview .bm-main-image__sku-list .sku-matched-row {
  background: #f0f9eb;
}

.bm-main-image__preview .bm-main-image__sku-list .sku-unmatched-row {
  background: #f5f5f5;
  color: #909399;
}

.bm-main-image__preview .bm-main-image__sku-list .sku-failed-row {
  background: #fef0f0;
}

.bm-main-image__preview .bm-main-image__sku-list .sku-matched-row:hover {
  background: #e1f3d8;
}

.bm-main-image__preview .bm-main-image__sku-list .sku-unmatched-row:hover {
  background: #ebebeb;
}

.bm-main-image__preview .bm-main-image__sku-list .sku-failed-row:hover {
  background: #fde2e2;
}

.bm-main-image__preview textarea {
  width: 100%;
  min-height: 38px;
  box-sizing: border-box;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  font-size: 11px;
}

.bm-main-image__preview .title-cell textarea {
  min-width: 300px;
  padding: 5px;
  line-height: 1;
  background: #fafcff;
  resize: vertical;
}

.bm-main-image__preview td button {
  height: 24px;
  border: 1px solid #91caff;
  border-radius: 3px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 10px;
}

.bm-main-image__field {
  min-width: 0;
}

.bm-main-image__preview .action-cell {
  min-width: 110px;
  white-space: nowrap;
}

.bm-main-image__preview .action-cell button {
  min-width: 82px;
  height: 30px;
  padding: 0 12px;
  border-color: #91caff;
  border-radius: 5px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 12px;
  line-height: 28px;
  transition: 0.2s;
}

.bm-main-image__preview .action-cell button + button {
  margin-left: 8px;
}

.bm-main-image__preview .action-cell button:disabled {
  border-color: #d9d9d9;
  background: #f5f5f5;
  color: #00000040;
  cursor: not-allowed;
  opacity: 0.6;
}

.bm-main-image__preview .action-cell button:disabled:hover {
  border-color: #d9d9d9;
  background: #f5f5f5;
  color: #00000040;
  transform: none;
}

.bm-main-image__preview .action-cell button:hover,
.bm-main-image__preview .action-cell button:focus {
  border-color: #409eff;
  background: #bae0ff;
  color: #0958d9;
}

.bm-main-image__preview .action-cell button:active {
  transform: translateY(1px);
}

.bm-main-image__preview .action-cell button.restore {
  border-color: #ffd591;
  background: #fff7e6;
  color: #d46b08;
}

.bm-main-image__preview .action-cell button.restore:hover,
.bm-main-image__preview .action-cell button.restore:focus {
  border-color: #ffa940;
  background: #ffe7ba;
  color: #ad4e00;
}

.bm-main-image__preview td button:hover {
  background: #bae0ff;
}

.bm-main-image__preview td button.restore {
  border-color: #ffd591;
  background: #fff7e6;
  color: #d46b08;
}

.bm-main-image__image {
  display: inline-flex;
  position: relative;
  z-index: 1;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffccd2;
  border-radius: 4px;
  background: #fff5f5;
  object-fit: cover;
  font-size: 16px;
  cursor: pointer;
}

.bm-main-image__pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 14px;
  border-top: 1px solid #f0f0f0;
  color: #666;
  font-size: 12px;
}

.bm-main-image__pagination button {
  padding: 4px 10px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
  background: #fff;
  color: #1677ff;
}

.bm-main-image__pagination button:disabled {
  color: #bbb;
  cursor: not-allowed;
}

.bm-main-image__pagination select {
  height: 26px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
}

::v-deep(.bm-main-image__image .el-image__inner) {
  border-radius: 4px;
  cursor: pointer;
}

.bm-main-image__bottom {
  position: fixed;
  left: var(--merchant-sidebar-width, 210px);
  right: 0;
  z-index: 20;
  bottom: 0;
  display: flex;
  width: auto;
  max-width: none;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  font-size: 12px;
}

.bm-main-image__bottom button {
  min-width: 0;
  flex: 0 1 auto;
  height: 30px;
  padding: 0 14px;
  border: 0;
  border-radius: 4px;
  color: #fff;
}

.bm-main-image__bottom .preview {
  background: #1677ff;
}

.bm-main-image__bottom .start {
  margin-left: auto;
  margin-right: 50px;
  padding: 0 28px;
  background: #52c41a;
}

.bm-main-image__bottom .time {
  background: #fff;
  color: #666;
  border: 1px solid #e0e0ec;
}

.bm-main-image__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}

.bm-main-image__select-modal,
.bm-main-image__small-modal {
  width: min(1180px, 96vw);
  min-width: 900px;
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.bm-main-image__small-modal {
  width: min(400px, 100%);
  min-width: 0;
}

.bm-main-image__select-modal > header,
.bm-main-image__small-modal > header {
  display: flex;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.bm-main-image__select-modal > header button,
.bm-main-image__small-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}

.bm-main-image__select-modal nav {
  display: flex;
  padding: 0 18px;
  border-bottom: 1px solid #e0e0ec;
}

.bm-main-image__select-modal nav button {
  padding: 10px 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-main-image__select-modal nav button.active {
  border-bottom-color: #1677ff;
  color: #1677ff;
}

.bm-main-image__select-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 18px;
  background: #fafafa;
}

.bm-main-image__selector-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  background: #fafafa;
}

.bm-main-image__selector-toolbar .bm-main-image__select-filter {
  flex: 1;
  padding: 0;
  background: transparent;
}

.bm-main-image__page-size {
  width: 96px;
}

.bm-main-image__select-all {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;
  gap: 6px;
  font-size: 12px;
}

.bm-main-image__select-filter .bm-main-image__group-select {
  width: 108px;
}

.bm-main-image__select-filter .bm-main-image__group-select .el-input,
.bm-main-image__select-filter .bm-main-image__group-select .el-input__inner {
  width: 108px;
}

.bm-main-image__select-filter .bm-main-image__group-select .el-input,
.bm-main-image__select-filter .bm-main-image__group-select .el-input__inner,
.bm-main-image__selector-pagination .bm-main-image__page-size .el-input,
.bm-main-image__selector-pagination .bm-main-image__page-size .el-input__inner {
  height: 28px;
  line-height: 28px;
}

::v-deep(.el-input__inner),
::v-deep(.el-input__icon) {
  height: 28px;
  line-height: 28px;
}

.bm-main-image__select-filter input {
  width: 150px;
  height: 28px;
}

.bm-main-image__selector-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 0;
  color: #666;
  font-size: 12px;
}

.bm-main-image__selector-pagination button {
  padding: 3px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
}

.bm-main-image__selector-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.bm-main-image__select-filter button {
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 11px;
}

.bm-main-image__select-modal main {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  max-height: 350px;
  padding: 14px 18px;
  overflow: auto;
}

.bm-main-image__select-modal main button {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 2px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #1a1a2e;
  text-align: left;
  min-height: 150px;
}

.bm-main-image__select-modal main button.selected {
  border-color: #1677ff;
  background: #e6f4ff;
}

.bm-main-image__select-modal main b {
  height: 48px;
  background: #fff5f5;
  font-size: 27px;
  text-align: center;
}

.bm-main-image__select-modal main img {
  width: 100%;
  height: 159px;
  object-fit: contain;
  background: #fff5f5;
}

.bm-main-image__select-modal main span {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bm-main-image__select-modal main small {
  color: #999;
  font-size: 10px;
}

.bm-main-image__select-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  padding: 10px 18px;
  border-top: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-main-image__select-modal footer > span {
  margin-right: auto;
}

.bm-main-image__select-modal footer button {
  background: #1677ff;
}

.bm-main-image__small-modal main {
  padding: 24px 20px;
  font-size: 13px;
}

.bm-main-image__small-modal main label {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bm-main-image__small-modal main input {
  height: 28px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
}

.bm-main-image__small-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}

.bm-main-image__small-modal .success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.bm-main-image__small-modal .success-message b {
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f6ffed;
  color: #52c41a;
  font-size: 28px;
}

.bm-main-image__small-modal .success-message p {
  margin: 12px 0 5px;
}

.bm-main-image__small-modal .success-message small {
  color: #999;
}

@media (max-width: 960px) {
  .bm-main-image__filter {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .bm-main-image__options span {
    margin-left: 0;
  }

  .bm-main-image__select-modal {
    min-width: 0;
  }

  .bm-main-image__select-modal main {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .bm-main-image__selector-toolbar {
    flex-wrap: wrap;
  }
}

@media (max-width: 720px) {
  .bm-main-image__filter {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-main-image__select-modal main {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-main-image__bottom .start {
    margin-left: 0;
  }
}

@media (max-width: 520px) {
  .bm-main-image__head,
  .bm-main-image__body {
    padding-right: 12px;
    padding-left: 12px;
  }

  .bm-main-image__filter {
    grid-template-columns: 1fr;
  }

  .bm-main-image__method-content input,
  .bm-main-image__method-content input.long,
  .bm-main-image__method-content textarea {
    width: 100%;
  }

  .bm-main-image__select-modal main {
    grid-template-columns: repeat(2, 1fr);
  }

  .bm-main-image__bottom {
    left: 0;
    gap: 6px;
    padding: 8px 12px;
  }

  .bm-main-image__bottom .start {
    padding: 0 12px;
  }

  .bm-main-image__bottom .preview {
    display: none;
  }
}

.bm-main-image__method-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
}

.bm-main-image__method-name input,
.bm-main-image__method-content input[type='checkbox'],
.bm-main-image__method-content input[type='radio'] {
  width: 14px;
  height: 14px;
  min-width: 14px;
  margin: 0;
  padding: 0;
  accent-color: #1677ff;
  cursor: pointer;
}

.bm-main-image__method-content {
  align-items: center;
  margin-top: 10px;
  padding-left: 22px;
  line-height: 28px;
}

.bm-main-image__method-content > label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  cursor: pointer;
}

.bm-main-image__method-content > span {
  flex-shrink: 0;
  color: #666;
  font-size: 12px;
}

.bm-main-image__method-content .bm-main-image__count-input,
.bm-main-image__method-content .bm-main-image__count-textarea {
  position: relative;
  line-height: normal;
}

.bm-main-image__method-content .bm-main-image__count-input input {
  width: 360px;
}

.bm-main-image__method-content .bm-main-image__count-input small,
.bm-main-image__method-content .bm-main-image__count-textarea small {
  position: absolute;
  right: 8px;
  bottom: 5px;
  color: #999;
  font: 10px 'JetBrains Mono', monospace;
}

.bm-main-image__method-content .bm-main-image__count-textarea textarea {
  width: 360px;
  padding-bottom: 18px;
}

.bm-main-image__method-content .bm-main-image__replace {
  width: 100%;
  gap: 8px;
}

.bm-main-image__method-content .bm-main-image__replace input {
  width: 160px;
}

.bm-main-image__replace .danger {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}

.bm-main-image__method-content .bm-main-image__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bm-main-image__method-content .bm-main-image__inline input:not([type='checkbox']):not([type='radio']) {
  width: 200px;
}

.bm-main-image__method-content select:disabled {
  background: #f5f5f5;
  color: #999;
}

.bm-main-image__method-content > .warning {
  display: block;
  width: 100%;
  line-height: 16px;
}

.bm-main-image__methods article {
  padding: 14px 14px 13px;
}

::v-deep(.bm-main-image__methods .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}

::v-deep(.bm-main-image__methods .el-checkbox__inner:hover),
::v-deep(.bm-main-image__methods .el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #d4a946;
}

::v-deep(.bm-main-image__methods .el-checkbox__input.is-checked .el-checkbox__inner),
::v-deep(.bm-main-image__methods .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}

::v-deep(.bm-main-image__methods .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}

::v-deep(.bm-main-image__methods .el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #1a1a2e;
}

.bm-main-image__select {
  width: 235px;
  line-height: normal;
}

.bm-main-image__filter-select {
  display: block;
  width: 100%;
}

.bm-main-image__date-range {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 5px;
}

.bm-main-image__date-input {
  flex: 1 1 0;
  min-width: 0;
  box-sizing: border-box;
  width: 0;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 11px;
}

.bm-main-image__date-separator {
  flex: 0 0 12px;
  color: #999;
  text-align: center;
}

.bm-main-image__store-select {
  width: 120px;
}

.bm-main-image__stores,
.bm-main-image__filter footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-main-image__filter .add-store {
  background: #722ed1;
}

.bm-main-image__filter .add-store:hover {
  background: #531dab;
}

::v-deep(.bm-main-image__select .el-input__inner),
::v-deep(.bm-main-image__filter-select .el-input__inner),
::v-deep(.bm-main-image__store-select .el-input__inner) {
  height: 28px;
  padding: 0 28px 0 8px;
  border-color: #e0e0ec;
  border-radius: 4px;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 28px;
  text-align: left;
}

::v-deep(.bm-main-image__select .el-input__suffix),
::v-deep(.bm-main-image__filter-select .el-input__suffix),
::v-deep(.bm-main-image__store-select .el-input__suffix) {
  right: 7px;
}

::v-deep(.bm-main-image__select .el-input__icon),
::v-deep(.bm-main-image__filter-select .el-input__icon),
::v-deep(.bm-main-image__store-select .el-input__icon) {
  color: #999;
  font-size: 14px;
  line-height: 28px;
}

::v-deep(.bm-main-image__select .el-input__inner:focus),
::v-deep(.bm-main-image__filter-select .el-input__inner:focus),
::v-deep(.bm-main-image__store-select .el-input__inner:focus) {
  border-color: #d4a946;
}

.bm-main-image__filter .more-search {
  padding: 0 2px;
  background: transparent;
  color: #1677ff;
}

.bm-main-image__more-modal {
  width: min(540px, 100%);
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.bm-main-image__more-modal > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.bm-main-image__more-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}

.bm-main-image__more-modal main {
  padding: 16px 18px;
}

.bm-main-image__more-modal .el-checkbox-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.bm-main-image__more-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}

.bm-main-image__more-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 12px;
}

.bm-main-image__more-modal footer .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

::v-deep(.bm-main-image__more-modal .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}

::v-deep(.bm-main-image__more-modal .el-checkbox__input.is-checked .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}

::v-deep(.bm-main-image__more-modal .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}

.bm-main-image__filter > footer {
  justify-content: space-between;
}

/* 价格范围首行同行，重复价格处理固定在第二行 */
.sku-scope-children-price {
  flex-wrap: wrap;
}

.sku-scope-children-price .sku-scope-mode,
.sku-scope-children-price .sku-scope-config {
  width: auto;
  flex: 0 0 auto;
}

.sku-scope-children-price .sku-scope-config {
  max-width: none;
}

.sku-scope-children-price .sku-scope-equal-price-row {
  flex: 0 0 100%;
  width: 100%;
}
</style>
<style>
.upload-box {
  display: inline-flex;
  width: 80px;
  height: 80px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #d9d9d9;
  border-radius: 4px;
  background: #fafafa;
  color: #999;
  cursor: pointer;
  transition: all 0.3s;
}

.upload-box:hover {
  border-color: #1677ff;
  color: #1677ff;
}

.upload-box.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.upload-box.is-disabled:hover {
  border-color: #dcdfe6;
  color: #999;
}

.upload-box.small {
  width: 80px;
  height: 80px;
}

.upload-box span {
  font-size: 24px;
  line-height: 1;
}

.upload-box small {
  margin-top: 8px;
  font-size: 11px;
}

.upload-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2px;
}

.image-select-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.selected-images {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.image-item {
  position: relative;
  width: 80px;
  height: 80px;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
}

.image-item .remove-img {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #ff4d4f;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-item .remove-img i {
  font-size: 12px;
}

.image-item .remove-img:hover {
  background: #ff7875;
}

.replace-images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
  width: 100%;
}

.replace-image-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.replace-image-slot label {
  font-size: 12px;
  color: #666;
  text-align: center;
}

.replace-image-slot .remove-btn {
  width: 80px;
  padding: 4px 10px;
  border: 1px solid #ff4d4f;
  border-radius: 4px;
  background: #fff;
  color: #ff4d4f;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.replace-image-slot .remove-btn:hover {
  background: #ff4d4f;
  color: #fff;
}

.replace-image-slot .remove-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.bm-main-image__methods {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-main-image__methods > header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  background: #f5f0e8;
  font-size: 12px;
  font-weight: 600;
}

.bm-main-image__methods > header p {
  display: inline-block;
  width: 3px;
  height: 14px;
  margin: 0;
  border-radius: 2px;
  background: #c8443c;
  vertical-align: middle;
}

.bm-main-image__methods article {
  padding: 14px 14px 13px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-main-image__methods article:last-child {
  border-bottom: 0;
}

.bm-main-image__method-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
}

.bm-main-image__method-content {
  margin-top: 10px;
  padding-left: 22px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  color: #666;
}

.bm-main-image__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

::v-deep(.bm-main-image__methods .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}

::v-deep(.bm-main-image__methods .el-checkbox__inner:hover),
::v-deep(.bm-main-image__methods .el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #d4a946;
}

::v-deep(.bm-main-image__methods .el-checkbox__input.is-checked .el-checkbox__inner),
::v-deep(.bm-main-image__methods .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}

::v-deep(.bm-main-image__methods .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}

::v-deep(.bm-main-image__methods .el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #1a1a2e;
}

::v-deep(.bm-main-image__methods .el-checkbox-group) {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

::v-deep(.bm-main-image__methods .el-radio-group) {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

::v-deep(.bm-main-image__methods .el-radio__label) {
  color: #1a1a2e;
  font-size: 12px;
}

.price-number-input {
  width: 160px;
  height: 28px;
  display: inline-flex;
  vertical-align: middle;
  line-height: 28px;
}

.price-number-input .el-input-number__increase,
.price-number-input .el-input-number__decrease {
  width: 22px;
  right: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  color: #606266;
  background: #f5f7fa;
  border-color: #dcdfe6;
}

.price-number-input .el-input-number__increase {
  top: 1px;
  height: 15px;
  border-radius: 0 3px 0 0;
}

.price-number-input .el-input-number__decrease {
  bottom: 1px;
  height: 15px;
  border-radius: 0 0 3px 0;
}

.price-number-input .el-input-number__increase i,
.price-number-input .el-input-number__decrease i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 1;
}

.price-number-input .el-input-number__increase:hover,
.price-number-input .el-input-number__decrease:hover {
  color: var(--el-color-primary, #409eff);
  background: #ecf5ff;
}

.price-number-input .el-input__inner {
  padding-left: 15px;
  padding-right: 26px;
  text-align: left;
}
</style>
<style>
.el-popper.bm-main-image__select-popper {
  z-index: 4000 !important;
}

.bm-main-image__methods > .el-radio-group,
.bm-main-image__methods article > .bm-main-image__method-content:first-child {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.bm-main-image__methods article > .bm-main-image__method-content {
  width: calc(100% - 22px);
}

.sku-methods {
  padding: 0;
  margin-bottom: 18px;
}

.sku-methods > header,
.price-methods > header {
  margin: 0;
  padding: 12px 16px;
  background: #f8f5ef;
  border-bottom: 1px solid #dfe3eb;
}

.sku-scope-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  border: 1px solid #8c98a8;
  border-radius: 50%;
  color: #6b7785;
  font-size: 11px;
  cursor: help;
}

.sku-scope-options {
  display: block;
  width: 100%;
  padding: 12px 16px;
}

.sku-scope-row-main {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 12px;
}

.sku-scope-row-main .el-checkbox {
  margin-right: 0;
}

.stock-range-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
}

.stock-range-inline .el-input-number {
  width: 120px;
}

.stock-range-inline .el-input-number >>> .el-input__inner {
  padding-left: 8px;
  padding-right: 32px;
}

.stock-range-inline span {
  font-size: 14px;
  color: #606266;
}

.sku-scope-row-detail {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-left: 0;
}

.sku-scope-row-detail .sku-scope-mode {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
}

.sku-scope-row-detail .sku-scope-config {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

.sku-scope-row-detail .sku-scope-config .bm-main-image__select .el-input {
  width: 235px;
  flex: 0 0 235px;
}

.sku-scope-row-detail .sku-scope-config .el-input {
  width: 300px;
  flex: 0 0 300px;
}

.sku-scope-row-detail .sku-keyword-count {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
  flex: 0 0 auto;
}

.sku-scope-option {
  display: flex;
  align-items: center;
  min-height: 32px;
  background: #fff;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.sku-scope-option:hover,
.sku-scope-option.active {
  /* background: #fffdf7; */
}

.sku-scope-option .el-radio {
  width: 100%;
  margin: 0;
}

.sku-scope-option > .el-radio {
  width: auto;
  flex: 0 0 auto;
}

.sku-scope-option .el-radio__label {
  color: #172b4d;
  font-weight: 600;
  white-space: normal;
  line-height: 20px;
}

.sku-scope-config sku-scope-all-config {
  margin: 0;
  padding: 12px 16px 14px 40px;
  border-bottom: 1px solid #e1e4eb;
  border-radius: 0;
  background: #fff;
}

.sku-scope-mode {
  display: inline-flex !important;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
}

.sku-scope-mode .el-radio {
  width: auto;
  margin: 0;
}

.sku-scope-mode .el-checkbox {
  margin: 0;
}

.sku-scope-block {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  border-bottom: 1px solid #e1e4eb;
  background: #fff;
}

.sku-scope-block > .el-radio {
  display: block;
  margin: 0;
  line-height: 24px;
}

.sku-scope-children {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: calc(100% - 28px);
  min-width: 0;
  box-sizing: border-box;
  margin: 6px 0 0 28px;
  padding-left: 14px;
  overflow-x: auto;
  overflow-y: hidden;
}

.sku-scope-children {
  gap: 8px 16px;
}

.sku-scope-children .sku-scope-mode,
.sku-scope-children .sku-scope-config {
  flex: 0 0 auto;
  width: auto;
  white-space: nowrap;
}

.sku-scope-children .el-checkbox {
  margin: 0;
  color: #606b78;
}

.sku-scope-equal-price-label {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}

.sku-scope-equal-price-row {
  display: flex;
  align-items: center;
  gap: 8px 16px;
  flex: 0 0 auto;
  white-space: nowrap;
}

.sku-scope-children-stacked {
  flex-direction: column;
  align-items: flex-start;
}

.sku-scope-children-stacked .sku-scope-config,
.sku-scope-children-stacked .sku-scope-equal-price-row {
  width: 100%;
}

.sku-scope-children-price {
  flex-wrap: wrap;
  overflow-x: auto;
}

.sku-scope-children-price .sku-scope-equal-price-row {
  flex: 0 0 100%;
}

/* 价格范围首行控件同行，第二行仅显示重复价格处理 */
.sku-scope-children-price .sku-scope-mode {
  width: auto;
  flex: 0 0 auto;
  flex-wrap: nowrap;
}

.sku-scope-children-price .sku-scope-config {
  width: auto;
  flex: 0 0 auto;
  max-width: none;
}

.sku-scope-children-price .sku-scope-equal-price-row {
  width: 100%;
  flex: 0 0 100%;
}

.sku-scope-children .sku-scope-config sku-scope-all-config {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 8px 0 0;
  border: 0;
}

.sku-scope-config sku-scope-all-config-label {
  flex: 0 0 auto;
  color: #606b78;
  line-height: 32px;
}

.sku-scope-all-config {
  display: inline-flex !important;
  align-items: center;
  vertical-align: middle;
  padding: 0 !important;
  border: 0 !important;
}

.sku-scope-children .sku-scope-mode {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.sku-scope-children .sku-scope-config {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  overflow: visible;
}

.sku-scope-children .sku-scope-config sku-scope-all-config .el-select {
  width: 210px;
}

.sku-scope-children .sku-scope-config sku-scope-all-config .el-input {
  width: 300px;
}

.sku-scope-extra {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 16px 10px 40px;
  border-bottom: 1px solid #e1e4eb;
  color: #606b78;
  font-size: 12px;
}

.sku-keyword-count {
  color: #909399;
  font-size: 12px;
  white-space: nowrap;
}

/* SKU 子项与配置按内容收缩，避免被 width:100% 强制撑满 */
.sku-scope-children {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
}

.sku-scope-children .sku-scope-mode {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  width: auto;
  max-width: max-content;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.sku-scope-children .sku-scope-config {
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  width: auto;
  max-width: 100%;
  min-width: 0;
  flex-wrap: nowrap;
  gap: 8px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.sku-scope-children .sku-scope-config > .el-select {
  flex: 0 0 235px;
  width: 235px;
}

.sku-scope-children .sku-scope-config > .el-input {
  flex: 0 0 350px;
  width: 350px;
  min-width: 0;
  max-width: 350px;
}

.sku-scope-children .sku-scope-config .sku-keyword-count {
  flex: 0 0 auto;
  white-space: nowrap;
}

::v-deep(.sku-scope-config .el-select .el-input__suffix) {
  right: 6px;
  display: flex;
  align-items: center;
}

::v-deep(.sku-scope-config .el-select .el-input__icon) {
  display: inline-block;
  width: 25px;
  color: #999;
  font-size: 14px;
  line-height: 28px;
}

::v-deep(.el-select.bm-main-image__select .el-input__inner) {
  width: 235px;
  box-sizing: border-box;
}

/* 五个 SKU 分组统一：配置控件固定在同一行 */
.sku-scope-children .sku-scope-mode {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  width: 100%;
}

.sku-scope-children .sku-scope-config {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  min-width: 0;
  overflow-x: auto;
}

.sku-scope-children .sku-scope-config > .el-select {
  flex: 0 0 235px;
  width: 235px;
}

.sku-scope-children .sku-scope-config > .el-input {
  flex: 0 0 350px;
  width: 350px;
  min-width: 0;
  max-width: 350px;
}

.sku-scope-children .sku-scope-config .sku-keyword-count {
  flex: 0 0 auto;
  white-space: nowrap;
}

.bm-main-image__methods:not(.sku-methods) article > .bm-main-image__method-content:first-child .el-radio-group {
  display: block;
  width: 100%;
}

.bm-main-image__methods:not(.sku-methods) article > .bm-main-image__method-content:first-child .el-radio {
  display: block;
  width: 100%;
  margin: 0 0 10px;
}

.bm-main-image__filter > footer {
  justify-content: flex-start;
}

.price-methods article {
  display: block;
  padding: 0;
}

.price-method {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  border: 0;
  border-bottom: 1px solid #e1e4eb;
  border-radius: 0;
  background: #fff;
  transition: background 0.2s;
}

.price-method:hover {
  background: #fafbfd;
}

.price-method.active {
  /* background: #fffdf7; */
  box-shadow: none;
}

.price-method.disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.price-method-title {
  flex: 0 0 150px;
  min-height: 32px;
  display: flex;
  align-items: center;
  padding: 0 12px 0 0;
}

.price-method-title .el-radio {
  display: block;
  width: 100%;
  margin: 0;
  line-height: 24px;
}

.price-method-title .el-radio__label {
  color: #172b4d;
  font-weight: 600;
}

.price-method-fields {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
  margin: 0;
  padding: 0 0 2px;
  border: 0;
  background: transparent;
}

.price-formula-row {
  display: flex;
  flex: 0 0 100%;
  width: 100%;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 6px;
  min-width: 0;
}

.price-formula-row .el-input,
.price-formula-row .el-input-number {
  width: 110px;
  flex: 0 1 110px;
}

.price-formula-row .el-radio-group {
  flex-wrap: nowrap;
  white-space: nowrap;
}

.price-method-fields .el-radio-group {
  display: flex;
  gap: 12px;
}

.price-method-fields .el-radio,
.price-method-fields .el-radio__label {
  font-size: 12px;
}

.price-method-fields .el-input {
  width: 160px;
}

.price-number-input {
  width: 160px;
  height: 28px;
  display: inline-flex;
  vertical-align: middle;
  line-height: 28px;
}

.price-number-input .el-input-number__increase,
.price-number-input .el-input-number__decrease {
  width: 22px;
  right: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  color: #606266;
  background: #f5f7fa;
  border-color: #dcdfe6;
}

.price-number-input .el-input-number__increase {
  top: 1px;
  height: 15px;
  border-radius: 0 3px 0 0;
}

.price-number-input .el-input-number__decrease {
  bottom: 1px;
  height: 15px;
  border-radius: 0 0 3px 0;
}

.price-number-input .el-input-number__increase i,
.price-number-input .el-input-number__decrease i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 1;
}

.price-number-input .el-input-number__increase:hover,
.price-number-input .el-input-number__decrease:hover {
  color: var(--el-color-primary, #409eff);
  background: #ecf5ff;
}

.price-number-input .el-input__inner {
  padding-left: 15px;
  padding-right: 26px;
  text-align: left;
}

.price-tail-help {
  color: #8c98a8;
  cursor: help;
}

.price-method-fields .bm-main-image__match {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.price-method-fields .bm-main-image__match button {
  border: 0;
  color: #f56c6c;
  background: transparent;
  cursor: pointer;
}

.price-method-fields > button {
  border: 1px solid #c8d2e3;
  border-radius: 3px;
  padding: 6px 10px;
  color: #245a9c;
  background: #fff;
  cursor: pointer;
}

.guard-options {
  padding: 12px 14px;
}

.guard-help {
  margin-left: 4px;
  color: #8c98a8;
  cursor: help;
}

.guard-tip {
  margin: 0 0 8px;
  color: #8c98a8;
  font-size: 11px;
  line-height: 18px;
}

.guard-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  min-height: 30px;
  color: #666;
  font-size: 12px;
  white-space: nowrap;
}

.guard-row + .guard-row {
  margin-top: 8px;
}

.guard-row .price-number-input {
  width: 150px;
  flex: 0 0 150px;
}

.price-cell {
  min-width: 150px;
  line-height: 24px;
  white-space: nowrap;
}

@media (max-width: 700px) {
  .price-method {
    display: block;
  }

  .price-method-title {
    width: 100%;
    padding: 0;
  }

  .price-method-fields {
    margin-top: 8px;
  }
}

@media (max-width: 520px) {
  .sku-scope-options {
    padding: 0;
  }

  .sku-scope-config sku-scope-all-config,
  .price-method-fields {
    padding-left: 0;
  }

  .price-method-fields .el-radio-group {
    flex-wrap: nowrap;
  }

  .price-formula-row {
    gap: 2px;
    font-size: 12px;
  }
  .price-formula-row .el-input,
  .price-formula-row .el-input-number {
    width: 72px;
    flex-basis: 72px;
  }

  .price-number-input {
    width: 72px;
  }

  .price-number-input .el-input-number__increase,
  .price-number-input .el-input-number__decrease {
    width: 18px;
  }

  .price-number-input .el-input-number__increase i,
  .price-number-input .el-input-number__decrease i {
    font-size: 10px;
  }

  .price-number-input .el-input__inner {
    padding-left: 8px;
    padding-right: 21px;
  }

  .guard-options {
    padding: 10px 0;
  }

  .guard-row {
    gap: 4px;
  }

  .guard-row .price-number-input {
    width: 90px;
    flex-basis: 90px;
  }
}
</style>